import { produce } from "immer";
import get from "lodash/get";
import { ActionTypes } from "./actions";
import { IAction, IDetailState } from "./types";

export const initialState = Object.freeze<IDetailState>({
    isFetching: false,
    isFetchingError: false,
    isNotFound: false,
    errorSKU: "",
    fetchingSKU: "",
    isFetchingAplusDataProgress: false,
    isFetchingAplusDataError: false,
});

export default (state: IDetailState = initialState, action: IAction): IDetailState =>
    produce(state, draft => {
        const { type, payload } = action;

        switch (type) {
            case ActionTypes.SET_SKU_DATA: {
                draft.skuData = payload;
                return;
            }

            case ActionTypes.FETCH_SKU_DATA_PROGRESS: {
                draft.fetchingSKU = payload;
                draft.isFetching = true;
                return;
            }

            case ActionTypes.FETCH_SKU_DATA_SUCCESS: {
                draft.isFetching = false;
                draft.isFetchingError = false;
                draft.isNotFound = false;
                draft.skuData = {
                    ...payload,
                    product: {
                        ...payload.product,
                        productInfo: payload.product.productInfoNew || payload.product.productInfo,
                    },
                };

                draft.errorSKU = "";
                return;
            }

            case ActionTypes.FETCH_SKU_DATA_FAILED: {
                draft.isFetching = false;
                draft.isNotFound = false;
                draft.isFetchingError = true;
                draft.errorSKU = payload;
                return;
            }

            case ActionTypes.FETCH_SKU_DATA_NOT_FOUND: {
                draft.isFetching = false;
                draft.isNotFound = true;
                draft.isFetchingError = false;
                draft.errorSKU = payload;
                return;
            }
            case ActionTypes.FETCH_A_PLUS_DATA_PROGRESS: {
                draft.isFetchingAplusDataProgress = true;
                draft.isFetchingAplusDataError = false;
                return;
            }

            case ActionTypes.FETCH_A_PLUS_DATA_SUCCESS: {
                draft.isFetchingAplusDataError = false;
                if (get(draft, "skuData.product")) {
                    draft.skuData.product.a_plus_data = payload;
                }
                return;
            }

            case ActionTypes.FETCH_A_PLUS_DATA_FAILED: {
                draft.isFetchingAplusDataProgress = false;
                draft.isFetchingAplusDataError = true;
                return;
            }

            case ActionTypes.FETCH_EXPLORE_DATA_SUCCESS: {
                const { images, productID } = payload;

                if (get(draft, "skuData.product.id") === productID) {
                    draft.skuData.product.productMedia = [
                        ...draft.skuData.product.productMedia,
                        ...images,
                    ];
                    draft.exploreProductID = productID;
                }
            }
        }
    });
